import React from 'react';

const Quote = ({ className }: { className?: string }) => {
	return (
		<svg
			xmlns="http://www.w3.org/2000/svg"
			width="111.3"
			height="86.1"
			viewBox="0 0 111.3 86.1"
			className={className}
		>
			<path
				id="What_s_new_at_Source"
				data-name="What’s new at Source"
				d="M12,128.4C12,147.9,24.6,159,38.7,159a23.946,23.946,0,0,0,23.7-23.7c0-12.9-9-21.6-20.4-21.6-2.4,0-5.1.3-6,.9,2.7-10.8,13.8-23.4,23.4-28.5L42.9,72.9C24.3,85.8,12,105.9,12,128.4Zm61.2,0c0,19.5,12.3,30.6,26.4,30.6a23.75,23.75,0,0,0,23.7-23.7c0-12.9-9-21.6-20.1-21.6-2.4,0-5.1.3-6,.9,2.4-10.8,13.8-23.4,23.4-28.5L103.8,72.9C85.2,85.8,73.2,105.9,73.2,128.4Z"
				transform="translate(-12 -72.9)"
				fill="currentColor"
			/>
		</svg>
	);
};

export default Quote;
